/* eslint-disable react/jsx-props-no-spreading */
import type { VoidFunctionComponent } from 'react';
import Licensing from './Licensing';
import Security from './Security';
import Quality from './Quality';
import { QualityRequired, SBOMRequired, SecurityRequired } from '../../../generic/Gates';
import useProjectIssuesSettings from './useProjectIssuesSettings';
import PageContent from '../shared/SettingsPageContent';
import Header from '../../../shared/settings/SettingsPageHeader';
import Redirect from '../../../generic/Redirect';
import { useAddToast } from '../../../../contexts/ToastContext';
import ProjectSBOMPoliciesSettings from './ProjectSBOMPoliciesSettings';
import useSBOMProjectSettings from './useSBOMProjectSettings';

/**
 * ProjectPoliciesSettingsContainer
 */
const ProjectPoliciesSettingsContainer: VoidFunctionComponent = () => {
  const {
    isLoading,
    isSaving,
    isSaveButtonDisabled,
    shouldShowIssues,
    projectSettingsBaseURL,
    onSave,
    licensing,
    security,
    quality,
  } = useProjectIssuesSettings();
  const addToast = useAddToast();
  const sbomSettings = useSBOMProjectSettings();

  if (!shouldShowIssues && !sbomSettings.canEditPolicy) {
    return (
      <Redirect to={projectSettingsBaseURL} />
    );
  }

  return (
    <PageContent isLoading={isLoading}>
      <Header heading="Policies">
        <Header.SaveButton
          isLoading={isSaving}
          isDisabled={isSaveButtonDisabled}
          onClick={() => {
            addToast({ type: 'info', content: 'Saving project settings and running issue scan...' });
            onSave();
          }}
        />
      </Header>
      <Licensing
        {...licensing}
      />
      <SecurityRequired>
        <Security
          {...security}
        />
      </SecurityRequired>
      <QualityRequired>
        <Quality
          {...quality}
        />
      </QualityRequired>
      <SBOMRequired>
        <ProjectSBOMPoliciesSettings {...sbomSettings} />
      </SBOMRequired>
    </PageContent>
  );
};

export default ProjectPoliciesSettingsContainer;
